/**
 * @generated SignedSource<<466609976e4b1d9796831e67d419efe0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type heroArticleThreeArticleIds$data = ReadonlyArray<{
  readonly node: {
    readonly entityId?: string;
  };
  readonly " $fragmentType": "heroArticleThreeArticleIds";
}>;
export type heroArticleThreeArticleIds$key = ReadonlyArray<{
  readonly " $data"?: heroArticleThreeArticleIds$data;
  readonly " $fragmentSpreads": FragmentRefs<"heroArticleThreeArticleIds">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "heroArticleThreeArticleIds",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "9a6822c9e5660b43ce1ab7f7aca6f7f3";

export default node;
